module.exports = __webpack_public_path__ + "assets/facebook_small.af6b81219e3b75acd13a1e35fc240c6e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/facebook_small.png
 ** module id = 122
 ** module chunks = 0
 **/